import React, { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
} from "@mui/material";

import dayjs from "dayjs";

import * as actions from "../../redux/actions/index";
import PageLoading from "../../components/PageLoading/PageLoading.component";
import Filter from "../../components/Filter/Filter.component";
import { TablePaginationActions } from "../../components/TablePaginationActions/TablePaginationActions.component";
import { FIRST_PAGE, PAGE_SIZE_OPTIONS } from "../../utils/paginationConstants";

const Redemptions = () => {
  const dispatch = useDispatch();
  const cmsAuth = useSelector((state) => state.cmsAuthenticator.cmsAuth || "");
  const redeems = useSelector((state) => state.cmsRedemptions.redeems || []);
  const total = useSelector((state) => state.cmsRedemptions.total || 0);
  const loading = useSelector(
    (state) => state.cmsRedemptions.fetchRedeemsLoading
  );
  const [sortedRedeems, setSortedRedeems] = useState([]);
  const [page, setPage] = useState(FIRST_PAGE);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

  const role = cmsAuth.role.toLowerCase().replace("_", "");

  useEffect(() => {
    dispatch(actions.onFetchRedeems(FIRST_PAGE, rowsPerPage, role));
  }, [dispatch]);

  useEffect(() => {
    setSortedRedeems(redeems);
  }, [redeems]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(actions.onFetchRedeems(newPage, rowsPerPage, role));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(FIRST_PAGE);
    dispatch(
      actions.onFetchRedeems(FIRST_PAGE, parseInt(event.target.value), role)
    );
  };

  const restrict =
    cmsAuth.role === "ADMIN" || cmsAuth.role === "CLIENT_VIEWER" ? (
      <Navigate to="/dashboard" />
    ) : null;
  return (
    <>
      {restrict}
      <PageLoading loading={loading} />
      <Filter page="redemptions" />
      <div className="Redemptions">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Id</TableCell>
                <TableCell align="center">User Id</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Points</TableCell>
                <TableCell align="center">Redeem Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {redeems.map((item, i) => {
                const date = item.created_at
                  ? dayjs(item.created_at).format("MM/DD/YYYY h:mm A")
                  : null;
                return (
                  <TableRow key={i} hover>
                    <TableCell align="center" component={Link}>
                      {item.id}
                    </TableCell>

                    <TableCell align="center" component={Link}>
                      {item.user_id}
                    </TableCell>

                    <TableCell align="center" component={Link}>
                      {item.type}
                    </TableCell>

                    <TableCell align="center">₱ {item.points}</TableCell>
                    <TableCell align="center">{date}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                  colSpan={5}
                  count={total}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default Redemptions;
